import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {  Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { DialogTitle, TextField } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {}
}));

const AddRole = props => {
  const { className, ...rest } = props;
  const [open, setOpen] = React.useState(true);
  const [rolename, setRolename] = React.useState('');
  const [roleobj, setRoleobj] = React.useState(props.roleObj ? props.roleObj : {});

  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState('sm');
  const classes = useStyles();
  const handleSave = () => {
    props.onUpdate(rolename, roleobj)
  };
  const handleinputchange = type => e => {
    setRolename(e.target.value)
    setRoleobj({ ...roleobj, name: e.target.value })
  };
  const handleClose = () => {
    setOpen(false);
    props.onDismiss()
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{roleobj?.id ? "Update Master Role" : "Add Master Role"}</DialogTitle>
        <DialogContent>

          <TextField
            variant="outlined"
            margin="dense"
            fullWidth
            value={roleobj ? roleobj.name : null}
            autoComplete="off"
            id="vendordeliverydays"
            name="vendordeliverydays"
            onChange={handleinputchange('name')}
            label="Name"
          />

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="default">
            Cancel
          </Button>
          <Button onClick={handleSave} variant="contained" color="primary" autoFocus>
            {roleobj?.id ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

AddRole.propTypes = {
  className: PropTypes.string
};

export default AddRole;
